import React from 'react';
import Header from 'cccisd-header';
import style from './style.css';

const Fortress = window.cccisd.fortress;
const Appdefs = window.cccisd.appDefs;

const NavBar = () => {
    let primaryNavLinks = [];
    try {
        primaryNavLinks = Appdefs.navs.find(n => n.handle === 'primaryNav').nav;
    } catch (e) {
        // meh, leave it empty
    }

    if (!primaryNavLinks.some(navItem => navItem.label === 'Resource Center')) {
        primaryNavLinks.push({
            label: 'Resource Center',
            url: '/resourceCenter',
            highlight: ['/resourceCenter'],
        });
    }

    return (
        <Header
            containerClassName="container-fluid"
            wrapperClassName={style.wrapper}
            logoClassName={style.logo}
            primaryNavLinks={primaryNavLinks}
            secondaryNavLinks="mainNav"
            showHomeAction={false}
            showAlertAction={false}
            showAdminAction={Fortress.isSuperUser()}
        />
    );
};

export default NavBar;
